<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-body">
          <usersTable :users="content" />
        </div>
        <pagination :allData="users" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import usersTable from '@/components/general/users/allUsers/usersTable.vue';
import Users from '@/data/users.json';
import pagination from '@/layouts/elements/pagination.vue';
import { useFunctionalitiesStore } from '@/store/functionalities';
import { storeToRefs } from 'pinia';

const functionalitiesStore = useFunctionalitiesStore();
const { state } = storeToRefs(functionalitiesStore);
const users = ref(Users.data);

const content = computed(() => state.value.content);
</script>

<style></style>
